import React from 'react';
import styled from 'styled-components';
import { WidthOrHeight } from 'ui/templates/ComponentWrapper/ComponentWrapper';

export interface TooltipPosition {
  top?: WidthOrHeight;
  right?: WidthOrHeight;
  bottom?: WidthOrHeight;
  left?: WidthOrHeight;
}

export interface Props {
  elementOnHover: React.ReactElement;
  id?: string;
  tooltipPosition?: TooltipPosition;
}

const StyledTooltip = styled.div<Pick<Props, 'tooltipPosition'>>`
  top: ${({ tooltipPosition }) => tooltipPosition?.top};
  right: ${({ tooltipPosition }) => tooltipPosition?.right};
  bottom: ${({ tooltipPosition }) => tooltipPosition?.bottom};
  left: ${({ tooltipPosition }) => tooltipPosition?.left};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  background-color: ${({ theme }) => theme.colors.b3};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: ${({ theme }) => theme.borderRadius}px;
  position: absolute;
  z-index: 100;
  visibility: hidden;
`;

const StyledContainer = styled.div`
  position: relative;
  display: inline-block;

  &:hover {
    & ${StyledTooltip} {
      visibility: visible;
    }
  }
`;

const Tooltip: React.FC<React.PropsWithChildren<Props>> = ({
  elementOnHover,
  tooltipPosition = { top: '50%', right: '50%', bottom: undefined, left: undefined },
  id,
  children
}) => (
  <StyledContainer data-testid="tooltip">
    <StyledTooltip tooltipPosition={tooltipPosition} id={id}>
      <div>{elementOnHover}</div>
    </StyledTooltip>
    {children}
  </StyledContainer>
);
export default Tooltip;
